export default __webpack_public_path__ + "images/logoBynacht.93ff6f53b022d6c96a2dd6b5aff07764.svg"